/* eslint-disable @typescript-eslint/no-unused-vars, react-hooks/exhaustive-deps, import/no-anonymous-default-export, no-useless-escape */
import React,{useState,useEffect,useCallback} from 'react';
import Layout from '../components/layout/Layout';
import {Input,Select} from '../components/common/FormField';
import Spinner from '../components/common/Spinner';
import api from '../services/api';

const BASE = process.env.REACT_APP_API_URL;

async function fetchTerm(path:string){
  const r=await fetch(`${BASE}${path}`,{headers:{Authorization:`Bearer ${localStorage.getItem('accessToken')}`}});
  return r.json();
}

export default function TerminologyPage(){
  const [tab,setTab]=useState<'icd10'|'snomed'|'loinc'|'mapping'>('icd10');
  const [query,setQuery]=useState('');
  const [results,setResults]=useState<any[]>([]);
  const [loading,setLoading]=useState(false);
  const [selected,setSelected]=useState<any>(null);
  const [stats,setStats]=useState<any>({});
  const [commonLab,setCommonLab]=useState<any[]>([]);
  const [commonSNOMED,setCommonSNOMED]=useState<any>({});
  const [vitalLOINC,setVitalLOINC]=useState<any[]>([]);

  useEffect(()=>{
    fetchTerm('/terminology/stats').then(r=>setStats(r.data||r||{})).catch(()=>{});
    fetchTerm('/terminology/loinc/lab-common').then(r=>setCommonLab(r.data||r||[])).catch(()=>{});
    fetchTerm('/terminology/snomed/common').then(r=>setCommonSNOMED(r.data||r||{})).catch(()=>{});
    fetchTerm('/terminology/loinc/vitals').then(r=>setVitalLOINC(r.data||r||[])).catch(()=>{});
  },[]);

  const search=useCallback(async()=>{
    if(!query||query.length<2){setResults([]);return;}
    setLoading(true);
    try{
      const path=tab==='icd10'?`/terminology/icd10/search?q=${encodeURIComponent(query)}&limit=20`:
                 tab==='snomed'?`/terminology/snomed/search?q=${encodeURIComponent(query)}&limit=20`:
                 `/terminology/loinc/search?q=${encodeURIComponent(query)}&limit=20`;
      const r=await fetchTerm(path);
      setResults(r.data||r||[]);
    }catch{setResults([]);}
    finally{setLoading(false);}
  },[query,tab]);

  useEffect(()=>{const t=setTimeout(search,350);return()=>clearTimeout(t);},[search]);

  const TABS=[['icd10','🏥 ICD-10'],['snomed','🧬 SNOMED CT'],['loinc','🔬 LOINC'],['mapping','🗺️ Mapping']];

  return(
    <Layout title="Clinical Terminology">
      {/* Stats */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-5">
        <div className="card p-4 text-center"><p className="text-2xl font-bold text-[#02357A]">{stats.icd10Count?.toLocaleString()||'70,000+'}</p><p className="text-sm text-slate-500 mt-0.5">ICD-10 Codes</p></div>
        <div className="card p-4 text-center"><p className="text-2xl font-bold text-green-600">{stats.snomedCount?.toLocaleString()||'350,000+'}</p><p className="text-sm text-slate-500 mt-0.5">SNOMED CT Concepts</p></div>
        <div className="card p-4 text-center"><p className="text-2xl font-bold text-purple-600">{stats.loincCount?.toLocaleString()||'95,000+'}</p><p className="text-sm text-slate-500 mt-0.5">LOINC Codes</p></div>
      </div>

      <div className="flex gap-2 mb-5">
        {TABS.map(([t,l])=>(
          <button key={t} onClick={()=>{setTab(t as any);setQuery('');setResults([]);setSelected(null);}}
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${tab===t?'bg-[#02357A] text-white shadow':'bg-white border border-slate-200 text-slate-600 hover:bg-slate-50'}`}>{l}</button>
        ))}
      </div>

      {tab!=='mapping'&&(
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-5">
          {/* Search Panel */}
          <div className="lg:col-span-2 space-y-3">
            <div className="card p-4">
              <label className="label text-xs">Search {tab==='icd10'?'ICD-10':tab==='snomed'?'SNOMED CT':'LOINC'}</label>
              <Input value={query} onChange={e=>setQuery(e.target.value)} placeholder={tab==='icd10'?'Search by code or description...':tab==='snomed'?'Search by term or concept ID...':'Search by name or LOINC number...'}/>
              {query.length>0&&query.length<2&&<p className="text-xs text-slate-400 mt-1">Type at least 2 characters</p>}
            </div>

            {loading?<div className="card p-4"><Spinner size="6"/></div>:results.length>0&&(
              <div className="card overflow-hidden max-h-[500px] overflow-y-auto">
                {results.map((r:any,i)=>(
                  <div key={i} onClick={()=>setSelected(r)}
                    className={`p-3 border-b border-slate-100 cursor-pointer hover:bg-slate-50 transition-all ${selected===r?'bg-blue-50':''}`}>
                    {tab==='icd10'&&<>
                      <p className="font-mono text-xs font-bold text-[#02357A]">{r.code}</p>
                      <p className="text-sm text-slate-700 mt-0.5 leading-tight">{r.description}</p>
                      {r.shortDescription&&<p className="text-xs text-slate-400 mt-0.5">{r.shortDescription}</p>}
                    </>}
                    {tab==='snomed'&&<>
                      <p className="font-mono text-xs font-bold text-green-600">{r.conceptId}</p>
                      <p className="text-sm text-slate-700 mt-0.5">{r.preferredTerm}</p>
                      <div className="flex gap-1 mt-1">
                        {r.semanticTag&&<span className="text-xs bg-green-50 text-green-700 px-1.5 py-0.5 rounded">{r.semanticTag}</span>}
                        {r.icd10Map&&<span className="text-xs bg-blue-50 text-[#02357A] px-1.5 py-0.5 rounded">ICD: {r.icd10Map}</span>}
                      </div>
                    </>}
                    {tab==='loinc'&&<>
                      <p className="font-mono text-xs font-bold text-purple-600">{r.loincNum}</p>
                      <p className="text-sm text-slate-700 mt-0.5">{r.longCommonName}</p>
                      <div className="flex gap-1 mt-1">
                        {r.loincClass&&<span className="text-xs bg-purple-50 text-purple-700 px-1.5 py-0.5 rounded">{r.loincClass}</span>}
                        {r.exampleUnits&&<span className="text-xs bg-slate-100 text-slate-600 px-1.5 py-0.5 rounded">{r.exampleUnits}</span>}
                      </div>
                    </>}
                  </div>
                ))}
              </div>
            )}
            {query.length>=2&&!loading&&results.length===0&&(
              <div className="card p-6 text-center"><p className="text-slate-500 text-sm">No results found for "{query}"</p></div>
            )}
          </div>

          {/* Detail Panel */}
          <div className="lg:col-span-3">
            {selected?(
              <div className="card p-5">
                <div className="flex justify-between items-start mb-4">
                  <div>
                    <span className={`font-mono text-lg font-black ${tab==='icd10'?'text-[#02357A]':tab==='snomed'?'text-green-600':'text-purple-600'}`}>
                      {tab==='icd10'?selected.code:tab==='snomed'?selected.conceptId:selected.loincNum}
                    </span>
                    <p className="text-slate-500 text-xs mt-0.5">{tab==='icd10'?'ICD-10-CM Code':tab==='snomed'?'SNOMED CT Concept':'LOINC Code'}</p>
                  </div>
                  <button onClick={()=>navigator.clipboard.writeText(tab==='icd10'?selected.code:tab==='snomed'?selected.conceptId:selected.loincNum)} className="btn-secondary text-xs py-1 px-3">📋 Copy</button>
                </div>

                {tab==='icd10'&&(
                  <div className="space-y-3">
                    <div><p className="text-xs text-slate-400 uppercase tracking-wide">Description</p><p className="font-semibold text-slate-800 mt-0.5">{selected.description}</p></div>
                    {selected.shortDescription&&<div><p className="text-xs text-slate-400 uppercase tracking-wide">Short Description</p><p className="text-slate-700 mt-0.5">{selected.shortDescription}</p></div>}
                    {selected.chapter&&<div><p className="text-xs text-slate-400 uppercase tracking-wide">Chapter</p><p className="text-slate-700 mt-0.5"><span className="font-mono font-bold">{selected.chapter}</span> — {selected.chapterTitle}</p></div>}
                    {selected.section&&<div><p className="text-xs text-slate-400 uppercase tracking-wide">Section</p><p className="text-slate-700 mt-0.5">{selected.section} — {selected.sectionTitle}</p></div>}
                    {selected.inclusionTerms&&<div><p className="text-xs text-slate-400 uppercase tracking-wide">Inclusion Terms</p><p className="text-slate-600 text-sm mt-0.5">{selected.inclusionTerms}</p></div>}
                    {selected.excludes1&&<div className="bg-red-50 p-3 rounded-lg"><p className="text-xs text-red-600 font-semibold">Excludes 1 (Not coded here)</p><p className="text-red-700 text-sm mt-0.5">{selected.excludes1}</p></div>}
                  </div>
                )}

                {tab==='snomed'&&(
                  <div className="space-y-3">
                    <div><p className="text-xs text-slate-400 uppercase tracking-wide">Preferred Term</p><p className="font-semibold text-slate-800 mt-0.5">{selected.preferredTerm}</p></div>
                    {selected.fullySpecifiedName&&<div><p className="text-xs text-slate-400 uppercase tracking-wide">Fully Specified Name</p><p className="text-slate-700 mt-0.5">{selected.fullySpecifiedName}</p></div>}
                    {selected.hierarchy&&<div><p className="text-xs text-slate-400 uppercase tracking-wide">Hierarchy</p><span className="inline-block mt-0.5 bg-green-50 text-green-700 text-xs px-2 py-0.5 rounded font-medium">{selected.hierarchy}</span></div>}
                    {selected.semanticTag&&<div><p className="text-xs text-slate-400 uppercase tracking-wide">Semantic Tag</p><span className="inline-block mt-0.5 bg-blue-50 text-[#02357A] text-xs px-2 py-0.5 rounded font-medium">{selected.semanticTag}</span></div>}
                    {selected.icd10Map&&<div className="bg-blue-50 p-3 rounded-lg"><p className="text-xs text-[#02357A] font-semibold">ICD-10 Mapping</p><span className="font-mono font-bold text-[#02357A]">{selected.icd10Map}</span></div>}
                    {selected.synonyms&&<div><p className="text-xs text-slate-400 uppercase tracking-wide">Synonyms</p><p className="text-slate-600 text-sm mt-0.5">{selected.synonyms}</p></div>}
                  </div>
                )}

                {tab==='loinc'&&(
                  <div className="space-y-3">
                    <div><p className="text-xs text-slate-400 uppercase tracking-wide">Long Common Name</p><p className="font-semibold text-slate-800 mt-0.5">{selected.longCommonName}</p></div>
                    {selected.shortName&&<div><p className="text-xs text-slate-400 uppercase tracking-wide">Short Name</p><p className="text-slate-700 mt-0.5">{selected.shortName}</p></div>}
                    <div className="grid grid-cols-2 gap-3">
                      {[['Component',selected.component],['Property',selected.property],['Time Aspect',selected.timeAspect],['System',selected.system],['Scale Type',selected.scaleType],['Method Type',selected.methodType],['LOINC Class',selected.loincClass],['Units',selected.exampleUnits]].map(([l,v])=>v&&(
                        <div key={l}><p className="text-xs text-slate-400 uppercase tracking-wide">{l}</p><p className="text-slate-700 text-sm mt-0.5 font-medium">{v}</p></div>
                      ))}
                    </div>
                  </div>
                )}

                <div className="mt-5 pt-4 border-t">
                  <button className="btn-primary text-sm" onClick={()=>navigator.clipboard.writeText(JSON.stringify(selected,null,2))}>📤 Copy as JSON</button>
                </div>
              </div>
            ):(
              <div className="space-y-4">
                {tab==='icd10'&&(
                  <div className="card p-5">
                    <h3 className="font-semibold text-slate-700 mb-3">Common ICD-10 Codes</h3>
                    <div className="space-y-1.5">
                      {[['I10','Essential hypertension'],['E11.9','Type 2 diabetes w/o complications'],['J06.9','Acute upper respiratory infection'],['K21.0','GERD with oesophagitis'],['M54.5','Low back pain'],['R50.9','Fever, unspecified'],['N39.0','UTI, site not specified'],['J18.9','Pneumonia, unspecified']].map(([code,desc])=>(
                        <div key={code} onClick={()=>{setQuery(code);}} className="flex items-center gap-3 p-2 rounded-lg hover:bg-slate-50 cursor-pointer">
                          <span className="font-mono text-xs font-bold text-[#02357A] w-16">{code}</span>
                          <span className="text-sm text-slate-600">{desc}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                {tab==='snomed'&&(
                  <div className="card p-5">
                    <h3 className="font-semibold text-slate-700 mb-3">Common Clinical Findings</h3>
                    <div className="space-y-1.5">
                      {(commonSNOMED.findings||[]).slice(0,8).map((s:any)=>(
                        <div key={s.conceptId} onClick={()=>setQuery(s.conceptId)} className="flex items-center gap-3 p-2 rounded-lg hover:bg-slate-50 cursor-pointer">
                          <span className="font-mono text-xs font-bold text-green-600 w-24">{s.conceptId}</span>
                          <span className="text-sm text-slate-600">{s.preferredTerm}</span>
                          {s.icd10Map&&<span className="ml-auto text-xs bg-blue-50 text-[#02357A] px-1.5 py-0.5 rounded">{s.icd10Map}</span>}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                {tab==='loinc'&&(
                  <div className="space-y-4">
                    <div className="card p-5">
                      <h3 className="font-semibold text-slate-700 mb-3">Common Lab Tests</h3>
                      <div className="space-y-1.5">
                        {commonLab.slice(0,8).map((l:any)=>(
                          <div key={l.loincNum} onClick={()=>setQuery(l.loincNum)} className="flex items-center gap-3 p-2 rounded-lg hover:bg-slate-50 cursor-pointer">
                            <span className="font-mono text-xs font-bold text-purple-600 w-20">{l.loincNum}</span>
                            <span className="text-sm text-slate-600">{l.test}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="card p-5">
                      <h3 className="font-semibold text-slate-700 mb-3">Vital Sign LOINC Codes</h3>
                      <div className="space-y-1.5">
                        {vitalLOINC.map((v:any)=>(
                          <div key={v.loincNum} className="flex items-center gap-3 p-2 rounded-lg hover:bg-slate-50">
                            <span className="font-mono text-xs font-bold text-purple-600 w-20">{v.loincNum}</span>
                            <span className="text-sm text-slate-600 flex-1">{v.vital}</span>
                            <span className="text-xs bg-slate-100 text-slate-600 px-1.5 py-0.5 rounded font-mono">{v.unit}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      )}

      {tab==='mapping'&&(
        <div className="space-y-5">
          <div className="card p-5">
            <h3 className="font-bold text-slate-800 mb-4">🗺️ Terminology Cross-Mapping</h3>
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mb-5">
              {[['ICD-10 → SNOMED','Map diagnosis codes to SNOMED concepts','I10 → Hypertension (38341003)','blue'],['SNOMED → ICD-10','Map clinical findings to billing codes','Fever (386661006) → R50.9','green'],['LOINC → HL7 FHIR','Map lab tests to FHIR Observation codes','CBC (58410-2) → Bundle.Observation','purple']].map(([t,d,e,c])=>(
                <div key={t as string} className={`p-4 rounded-xl bg-${c}-50 border border-${c}-100`}>
                  <h4 className={`font-semibold text-${c}-700 mb-1 text-sm`}>{t}</h4>
                  <p className={`text-${c}-600 text-xs mb-2`}>{d}</p>
                  <p className={`font-mono text-xs text-${c}-800 bg-${c}-100 px-2 py-1 rounded`}>{e}</p>
                </div>
              ))}
            </div>
            <div className="bg-slate-50 rounded-xl p-4">
              <h4 className="font-semibold text-slate-700 mb-3">ICD-10 to SNOMED Cross Reference</h4>
              <div className="space-y-2">
                {[['I10','Essential hypertension','38341003','Hypertensive disorder'],['E11.9','Type 2 DM w/o complications','44054006','Diabetes mellitus type 2'],['J45.9','Asthma, unspecified','195967001','Asthma'],['N18.9','Chronic kidney disease','431855005','CKD stage unspecified'],['I21.9','Acute MI, unspecified','22298006','Myocardial infarction']].map(([icd,idesc,snomed,sdesc])=>(
                  <div key={icd as string} className="flex items-center gap-3 bg-white p-3 rounded-lg border border-slate-200">
                    <div className="flex-1"><span className="font-mono text-xs font-bold text-[#02357A]">{icd}</span><span className="text-xs text-slate-500 ml-2">{idesc}</span></div>
                    <span className="text-slate-400">→</span>
                    <div className="flex-1"><span className="font-mono text-xs font-bold text-green-600">{snomed}</span><span className="text-xs text-slate-500 ml-2">{sdesc}</span></div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="card p-5">
            <h3 className="font-bold text-slate-800 mb-4">📊 Terminology in FHIR R4 Resources</h3>
            <div className="space-y-3">
              {[
                {resource:'Condition',system:'ICD-10 / SNOMED CT',example:'code: {system: "http://hl7.org/fhir/sid/icd-10", code: "I10", display: "Essential hypertension"}'},
                {resource:'Observation (Vitals)',system:'LOINC',example:'code: {system: "http://loinc.org", code: "8310-5", display: "Body temperature"}'},
                {resource:'MedicationRequest',system:'RxNorm / SNOMED',example:'medicationCodeableConcept: {system: "http://www.nlm.nih.gov/research/umls/rxnorm", code: "723"}'},
                {resource:'DiagnosticReport',system:'LOINC',example:'code: {system: "http://loinc.org", code: "11502-2", display: "Laboratory report"}'},
                {resource:'Procedure',system:'SNOMED CT',example:'code: {system: "http://snomed.info/sct", code: "80146002", display: "Appendectomy"}'},
              ].map(r=>(
                <div key={r.resource} className="bg-slate-50 p-3 rounded-lg">
                  <div className="flex items-center gap-2 mb-1.5"><span className="text-xs font-bold text-[#02357A] bg-blue-100 px-2 py-0.5 rounded">{r.resource}</span><span className="text-xs text-slate-500">uses {r.system}</span></div>
                  <pre className="text-xs text-slate-600 font-mono bg-white p-2 rounded border border-slate-200 overflow-x-auto">{r.example}</pre>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
}
